// <s-announcement data-interval="4500">: each [data-announcement] rises in from the bottom edge and floats out the top, in turn.
// Hover or keyboard focus pauses rotation; hidden tabs and reduced-motion users keep the first message.
class Announcement extends HTMLElement {
  #timer = null;
  #index = 0;
  #paused = false;
  #abort = null;

  connectedCallback() {
    this.items = [...this.querySelectorAll('[data-announcement]')];
    if (this.items.length < 2) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.#abort = new AbortController();
    const { signal } = this.#abort;
    const pause = () => {
      this.#paused = true;
    };
    const resume = () => {
      this.#paused = false;
    };
    this.addEventListener('pointerenter', pause, { signal });
    this.addEventListener('pointerleave', resume, { signal });
    this.addEventListener('focusin', pause, { signal });
    this.addEventListener('focusout', resume, { signal });

    const interval = Number(this.dataset.interval) || 4500;
    this.#timer = setInterval(() => {
      if (this.#paused || document.hidden) return;
      this.#show((this.#index + 1) % this.items.length);
    }, interval);
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
    this.#abort?.abort();
  }

  #show(next) {
    // The outgoing message floats up and out (data-leaving), then quietly resets below the edge.
    const outgoing = this.items[this.#index];
    outgoing.setAttribute('data-leaving', '');
    outgoing.removeAttribute('data-active');
    outgoing.setAttribute('aria-hidden', 'true');
    setTimeout(() => outgoing.removeAttribute('data-leaving'), 1100);
    this.#index = next;
    this.items[next].setAttribute('data-active', '');
    this.items[next].removeAttribute('aria-hidden');
  }
}

if (!customElements.get('s-announcement')) customElements.define('s-announcement', Announcement);
